import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { ApexCharts } from '../../../Components'

export default function ObjChart({ dataGrid }) {
  const [interacoesPorTipo, setInteracoesPorTipo] = useState([])

  useEffect(() => {
    if (dataGrid) {
      const interacoesPorTipo = contarInteracoesPorTipo(dataGrid)
      setInteracoesPorTipo(interacoesPorTipo)
    }
  }, [dataGrid])

  const contarInteracoesPorTipo = (dataGrid) => {
    const interacoesPorTipo = {
      'Análises e Ensaios Laboratoriais': 0,
      'Serviços Tecnológicos': 0,
    }

    dataGrid.forEach((item) => {
      if (item.tpServico != 0) {
        const tipoServico = item.tpServico == 1 ? 'Análises e Ensaios Laboratoriais' : 'Serviços Tecnológicos'
        interacoesPorTipo[tipoServico]++
      }
    })

    return Object.entries(interacoesPorTipo).map(([tipoServico, interacoes]) => ({ tipoServico, interacoes }))
  }

  const config = {
    series: interacoesPorTipo.map((item) => item.interacoes),
    options: {
      chart: {
        width: 350,
        type: 'pie',
      },
      labels: interacoesPorTipo.map((item) => item.tipoServico),
      legend: {
        show: true,
        position: 'bottom',
      },
      colors: ['#20c997', '#0170B9'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }

  return (
    <Card className="main-card mb-2">
      <CardHeader>Interações por tipo de serviço</CardHeader>
      <CardBody style={{ textAlign: 'center' }}>
        <ApexCharts options={config.options} series={config.series} type="pie" height={395} />
      </CardBody>
    </Card>
  )
}
